module.exports = __webpack_public_path__ + "img/QR-zh.19751573.jpg";